import { debugLog } from "../../Utils/utils";

class MessagePublisher {
  constructor(connectionManager) {
    this._conn = connectionManager;
  }

  sendMessage(messageData, token) {
    if (!messageData?.content || !messageData?.senderId) {
      return;
    }

    if (!this._conn.client || !this._conn.connected) {
      debugLog("[StompChat] Connection dead, queuing message for retry after reconnect");
      const unsub = this._conn.onReconnect(() => {
        unsub();
        if (this._conn.client && this._conn.connected) {
          this._doSendMessage(messageData, token);
        } else {
          debugLog("[StompChat] Retry failed — still disconnected");
        }
      });
      this._conn._forceReconnect();
      return;
    }

    this._doSendMessage(messageData, token);
  }

  _doSendMessage(messageData, token) {
    const payload = {
      content: messageData.content,
      senderId: messageData.senderId,
      ...(messageData.chatId ? { chatId: messageData.chatId } : {}),
      ...(messageData.chatType ? { chatType: messageData.chatType } : {}),
      ...(messageData.mode ? { mode: messageData.mode } : {}),
      ...(messageData.voiceMode ? { voiceMode: true } : {}),
      ...(messageData.pageContext ? { pageContext: messageData.pageContext } : {}),
    };

    this._conn.client.publish({
      destination: "/app/message",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });
  }

  sendTyping(token, typingData) {
    if (!this._conn.client || !this._conn.connected) return;

    const payload = typeof typingData === 'string'
      ? { chatId: typingData }
      : {
          senderId: typingData.senderId,
          chatId: typingData.chatId,
          targetId: typingData.targetId
        };

    this._conn.client.publish({
      destination: "/app/typing",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
  }

  sendStopTyping(token, typingData) {
    if (!this._conn.client || !this._conn.connected) return;

    const payload = typeof typingData === 'string'
      ? { chatId: typingData }
      : {
          senderId: typingData.senderId,
          chatId: typingData.chatId,
          targetId: typingData.targetId
        };

    this._conn.client.publish({
      destination: "/app/stop-typing",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
  }

  sendGroupTyping(token, groupTypingData) {
    if (!this._conn.client || !this._conn.connected) return;

    const payload = {
      senderId: groupTypingData.senderId,
      groupId: groupTypingData.groupId,
      targetId: groupTypingData.targetId || groupTypingData.groupId
    };

    this._conn.client.publish({
      destination: "/app/social/typing/group",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
  }

  sendGroupStopTyping(token, groupTypingData) {
    if (!this._conn.client || !this._conn.connected) return;

    const payload = {
      senderId: groupTypingData.senderId,
      groupId: groupTypingData.groupId,
      targetId: groupTypingData.targetId || groupTypingData.groupId
    };

    this._conn.client.publish({
      destination: "/app/social/stop-typing/group",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
  }

  sendGroupMessage(token, messageData) {
    if (!this._conn.client || !this._conn.connected) return;

    if (!messageData?.content || !messageData?.groupId) {
      return;
    }

    const payload = {
      content: messageData.content,
      groupId: messageData.groupId,
    };

    this._conn.client.publish({
      destination: "/app/social/message/group",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });
  }
}

export default MessagePublisher;
